import { css } from 'styled-system/css';

export const betsPanelStyle = {
	container: css({
		base: {
			display: 'flex',
			flexDirection: 'column',
			flex: 1,
			'& .mybets': {
				// aside mybet
				p: '6px'
			}
		}
	}),
	tabSwitch: css({
		base: {
			'--rp-tab-switch-h': '42px',
			position: 'sticky',
			top: '52px',
			zIndex: '25',
			h: 'var(--rp-tab-switch-h)',
			bgColor: 'var(--body-bg)',
		},
		_galaxy: {
			'& .rp-tab-button:not([data-selected="true"]):hover': {
				color: 'var(--text-primary-700-200)',
			}
		}
	}),
	asideBetSlip: css({
		base: {
			flex: 1,
		}
	}),
	hasBet: css({
		base: {
			'& .bet-slip': {
				h: '100%',
			}
		}
	}),
	betslipAsideEmpty: css({
		base: {
			p: '6px 6px 0 6px',
		},
	}),
	betslipTap: css({
		base: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			gap: '5px',
		}
	}),
	betslipBadge: css({
		_mars: {
			fontSize: '12px',
			fontWeight: '500',
			textAlign: 'center',
			minW: '21px',
			minH: '21px',
			borderRadius: '6px',
			color: 'sideMenuBtn.selectedBadge.text',
			bgColor: 'sideMenuBtn.selectedBadge.bg'
		}
	}),
	// galaxy獨立投注+aside模式需要有padding 
	betslipAsideGalaxyIndep: css({
		base: {
			p: '9px 9px 0 9px',
			'& .bet-slip-area': {
				p: 0
			},
			'& .single-area-wrap  > :first-child': {
				borderTopRadius: '0',
			},  
			'& .bet-slip': {
				borderTopRadius: '9px',
			},
			'& .bet-slip__switch': {
				borderTopRadius: '9px',
			},
			// 但footer不需要, 利用此css抵銷Padding
			'& .bet-slip__independent-bottom': {
				w: 'calc(100% + 18px)',
				borderRadius: 0,
				_ltr: {
					transform: 'translateX(-9px)',
				},
				_rtl: {
					transform: 'translateX(9px)',
				},
			}
		}
	})
}